import { Child } from "@kanpla/types";

export const getChildGroupName = (selectors: Child["selectors"]) =>
  Object.keys(selectors || {})
    .sort((a, b) => a.localeCompare(b, "en"))
    .map((key) => (selectors[key] === "一" ? "" : selectors[key]))
    .join("");
